/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAOffIcon16Light = forwardRef('MediaAudioVolumeAOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.793 5 1.646 1.854a.5.5 0 1 1 .708-.708l13 13a.5.5 0 0 1-.708.708L12 12.207v1.895a.9.9 0 0 1-1.502.669L6.308 11H3.5A1.5 1.5 0 0 1 2 9.5v-3A1.5 1.5 0 0 1 3.5 5h1.293ZM11 11.207v2.67l-4.023-3.62A1 1 0 0 0 6.308 10H3.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h2.293L11 11.207Z" }),
        React.createElement("path", { d: "M11 2.123v5.68l1 1V1.898a.9.9 0 0 0-1.502-.669L7.302 4.105l.708.708L11 2.123Z" })));
});
